/**
 * Identidade visual da marca-mãe **Codout** (codout.com), aplicada à landing do produto
 * Codout.Support (Produto Codout · SaaS). Extraída dos estilos computados do site: base clara
 * monocromática (tinta sobre #f4f7fa), tipografia Space Grotesk + JetBrains Mono, CTAs em pílula
 * tinta, e um accent ciano-azul usado com parcimônia (gradiente do H1, tag de produto, destaques).
 * O motivo "terminal/código" (traffic-lights mac, verde/âmbar) aparece pontualmente.
 *
 * Valores fiéis aos hexes do codout.com. As cores SEMÂNTICAS de estado (roxo=Suggest,
 * âmbar=AutoReply, verde=live, vermelho=destrutivo) continuam em `palette.ts`.
 */
export const brand = {
  ink: '#0b1520', // texto primário, fundo dos CTAs pílula, footer
  paper: '#ffffff',
  canvas: '#f4f7fa', // fundo da página
  canvasWarm: 'rgba(245, 241, 234, 0.75)', // nav frosted (levemente quente, como o codout.com)
  slate: '#5c6a78', // rótulos/mono e texto secundário
  inkSoft: '#3a4655', // corpo de texto sobre claro
  line: 'rgba(11, 21, 32, 0.1)', // divisórias sutis
  lineStrong: 'rgba(11, 21, 32, 0.22)', // borda dos botões ghost
  signal: '#1aafe8', // accent ciano-azul (brilhante)
  signalDeep: '#126a87', // accent sobre fundo claro (tag de produto, links)
  signalLight: '#5fc8f0', // accent sobre fundo escuro
  gradHi: 'linear-gradient(100deg, #0b1520 0%, #0b1520 52%, #126a87 76%, #1aafe8 100%)',
  live: '#12885a', // "ao vivo" — verde legível sobre claro
  liveSoft: 'rgba(18, 136, 90, 0.12)',
  termRed: '#ff5f57',
  termAmber: '#febc2e',
  termGreen: '#28c840',
  handoff: '#b26a1f', // âmbar do ícone/borda do handoff
  handoffStrong: '#8a5015', // âmbar mais escuro para TEXTO (AA >= 4.5:1 sobre handoffSoft)
  handoffSoft: '#fbeed7',
  agentBubble: '#ffffff',
  userBubble: '#0b1520',
  userText: '#ffffff',
  chip: '#eef2f6',
  shadowLg: '0 28px 64px -24px rgba(11, 21, 32, 0.32)',
  shadowSm: '0 2px 10px -3px rgba(11, 21, 32, 0.14)',
  radius: 16,
} as const

/** Famílias tipográficas da identidade Codout. */
export const fonts = {
  display: "'Space Grotesk', Figtree, system-ui, sans-serif",
  body: "'Space Grotesk', Figtree, system-ui, sans-serif",
  mono: "'JetBrains Mono', ui-monospace, monospace",
} as const
